import React from 'react';
import LazyImage from '../LazyImage/LazyImage';
import './BrowseByCity.css';

function BrowseByCity() {
  const cities = [
    {
      id: 1,
      name: 'Karachi',
      properties: '45,231',
      image: 'https://images.unsplash.com/photo-1709326955894-ed49938291ed?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8a2FyYWNoaSUyMGNpdHl8ZW58MHx8MHx8fDA%3D'
    },
    {
      id: 2,
      name: 'Lahore',
      properties: '38,942',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXKXoOKFLIaKpQ79i_z1OKZJAsDg64OTJlCg&s'
    },
    {
      id: 3,
      name: 'Islamabad',
      properties: '27,815',
      image: 'https://media.istockphoto.com/id/1454571436/photo/islamabad-is-the-capital-city-of-pakistan-beautiful-aerial-view-islamabad-pakistan.jpg?s=612x612&w=0&k=20&c=L1MJ2fmwIYH6CSreU93DYEb1iueox-KUyKKrLJML_iM='
    },
    {
      id: 4,
      name: 'Rawalpindi',
      properties: '18,654',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSojzsYcmEikmNV-atkcLDWQIPXbX1ciH2cfA&s'
    },
    {
      id: 5,
      name: 'Faisalabad',
      properties: '15,234',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQg8PezOf3Viw_3_2IMv4LUqkKWbZ17xgFk-A&s'
    },
    {
      id: 6,
      name: 'Multan',
      properties: '12,543',
      image: 'https://images.hive.blog/0x0/https://files.peakd.com/file/peakd-hive/mobi72/kZxEm2ki-image.png'
    }
  ];

  const handleCityClick = (cityName) => {
    // Store city filter in sessionStorage
    const searchParams = {
      city: cityName
    };
    sessionStorage.setItem('searchParams', JSON.stringify(searchParams));

    // Navigate to listings page with city filter
    if (window.navigateTo) {
      window.navigateTo('listings');
    } else {
      alert(`Navigating to ${cityName} properties`);
    }
  };

  return (
    <section className="browse-by-city">
      <div className="container">
        <div className="section-header">
          <h2>Browse Properties by City</h2>
          <p>Explore properties in major cities across Pakistan</p>
        </div>

        <div className="cities-grid">
          {cities.map(city => (
            <div
              key={city.id}
              className="city-card"
              onClick={() => handleCityClick(city.name)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleCityClick(city.name)}
              aria-label={`Browse ${city.properties} properties in ${city.name}`}
            >
              <div className="city-image">
                <LazyImage
                  src={city.image}
                  alt={city.name}
                  aspectRatio="4/3"
                />
                <div className="city-overlay"></div>
              </div>
              <div className="city-info">
                <h3>{city.name}</h3>
                <p>{city.properties} Properties</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BrowseByCity;
